<template>
	<counter v-bind="props">
		<div class="counter" slot-scope="{quantityC, inputKey, input}">
			<div class="input">
				<input type="tel" v-model="quantityC" @keypress="inputKey" @input="input"/>
			</div>
		</div>
	</counter>
</template>

<script>
import counter from "./counter";

export default {
	components: {counter},
	props: {
		props: {type: Object, required: true}
	}
};
</script>


<style lang="scss" scoped>
.counter {
	.input {
		input {
			outline: 0;
			font-size: 14px;
			appearance: none;
			border: 1px solid #C4CDD5;
			width: 39px;
			height: 26px;
			border-radius: 2px;
			text-align: center;
		}
	}
}
</style>
